import { Directive, inject, TemplateRef } from '@angular/core'
import { AccordionItemDirective } from './accordion-item.directive.js'

@Directive({
  selector: '[accordionHeader]',
  standalone: false,
})
export class AccordionHeaderDirective {
  public templateRef = inject<
    TemplateRef<{
      $implicit: AccordionItemDirective
      id: string
      toggle: () => void
    }>
  >(TemplateRef<Element>)
}
